import * as actions from "Actions";
import * as api from "Api";

export const fetchCategorySettingsSuggestions = ({ lng }) => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getCategorySettingsSuggestions(
        api.getCategoriesSettings(currentOrganization.id, null, lng)
      )
    );
  };
};

export const fetchCategoriesSettings = () => {
  return (dispatch, getState) => {
    const { currentOrganization } = getState().auth;
    return dispatch(
      actions.getCategoriesSettings(
        api.getCategoriesSettings(currentOrganization.id, null)
      )
    );
  };
};

export const updateCategorySettings = (categoryId, labels, isForced) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.updateCategorySettings(
      api.updateCategorySettings({
        organization: currentOrganization.id,
        id: categoryId,
        labels: labels,
        isForced: isForced
      })
    )
  );
};

export const deleteCategorySettings = (categoryId, isForced) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.deleteCategorySettings(
      api.deleteCategorySettings({
        organization: currentOrganization.id,
        isForced: isForced,
        id: categoryId
      })
    )
  );
};

export const saveCategorySettings = (labels, isBillable) => (
  dispatch,
  getState
) => {
  const { currentOrganization } = getState().auth;
  return dispatch(
    actions.saveCategorySettings(
      api.saveCategorySettings({
        organization: currentOrganization.id,
        labels: labels,
        isBillable: isBillable
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/categories.js